var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"stepsH5"},[_c('el-steps',{attrs:{"active":_vm.active,"finish-status":"success"}},_vm._l((_vm.titles),function(title,index){return _c('el-step',{key:index,attrs:{"title":title}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }